<template>
    <div class="contacts">
        <div class="container-fluid mx-0 px-0">
            <div class="row no-gutters">
                <div class="col-6 right-col">
                    <div class="vertical-center">
                    <h1>WE WANT TO HEAR FROM YOU</h1>
                    <h3>Let's work together to create game-changing experiences that will take your brand to the next level!</h3>
                    <address>
                        <h4>Address</h4>
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                        Avenida Columbano Bordalo Pinheiro, nº76<br>
                        1070-064 Lisboa<br>
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        (+351) 91 747 0661
                    </address>
                    <address>
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                        <a href="mailto:#">info@gobig.pt</a>
                    </address>
                </div>
                </div>
                <div class="col-6">
                    <div class="rafa-welcome" data-aos="fade-in" data-aos-easing="ease-in" data-aos-delay="300" data-aos-duration="1000">
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>

<script>
export default {
    name: 'Contacs',
        data () {
            return {
                msg: 'Welcome to App'
            }
        }
    }
</script>

<style lang="scss">
$orange: #f26522;
$white: #FFF;

.right-col{
    background:lighten($orange, 10);
    color:$white;
    height:100vh;
}

.rafa-welcome{
    background-image:url('../assets/img/rafa.jpg');background-position:top center; background-size:cover; margin:0; width: 100%; height: 100%;
}
</style>
